module.exports = __webpack_public_path__ + "static/livesync_concept-94ac2cfe3cc01da0bc29c761cd16a0f9.jpg";